import { render, staticRenderFns } from "./ReviewRetireMergeIdDetails.vue?vue&type=template&id=611bac08&scoped=true&"
import script from "./ReviewRetireMergeIdDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewRetireMergeIdDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRetireMergeIdDetails.vue?vue&type=style&index=0&id=611bac08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611bac08",
  null
  
)

export default component.exports